// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/style/base.css
// module id = 259
// module chunks = 148